import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalculator = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M4 6.25h12m-9.25 3h.5m-.5 3h.5m-.5 3h.5m2.5-6h.5m-.5 3h.5m-.5 3h.5m2.5-6h.5m-.5 3h.5m-.5 3h.5m-8 3h9.5a2 2 0 0 0 2-2V3.75a2 2 0 0 0-2-2h-9.5a2 2 0 0 0-2 2v12.5a2 2 0 0 0 2 2Z"
	})]
});
const ForwardRef = forwardRef(SvgCalculator);
export { ForwardRef as ReactComponent };
